import { render, staticRenderFns } from "./watchShopBox.vue?vue&type=template&id=756987e0&scoped=true&"
import script from "./watchShopBox.vue?vue&type=script&lang=js&"
export * from "./watchShopBox.vue?vue&type=script&lang=js&"
import style0 from "./watchShopBox.vue?vue&type=style&index=0&id=756987e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756987e0",
  null
  
)

export default component.exports